import React, { useState } from "react"
import "../../scss/vendorMasterCreation.scss";
import AdvanceSearch from "../../utilsComponent/advanceSearch";
import { useNavigate } from "react-router-dom";
import LoadingPage from "../../reusableComponents/loader/loadingPage";
import NoDataFound from "../../utilsComponent/noDataFound";
import ListsPagination from "../../utilsComponent/ListsPagination";
import { PAGE_NAME_KEYS } from "../../consts";

const Vendormaster = (props) => {
    const {productNames} = props
    const [loading, setLoading]=useState(false)
    const [vendorsList, setVendorsList] = useState([])
    const [searchResultMode, setSearchResultMode] = useState(false)
    const [resetPagination, setResetPagination] = useState(false)
    const defaultSearch = {
        vendorName :"",
        vendorId: "",
        mobileNumber: "",
        email: "",
        state: "",
        district: "" ,
        status: "" 
    }
    
    const [vendorSearch, setVendorSearch] = useState(defaultSearch)
    const [currentItems, setCurrentItems] = useState([])
    const [sortedVendorId, setSortedVendorId] = useState(true)
    const [sortedVendorName, setSortedVendorName] = useState(true)
    const [sortedMobile, setSortedMobile] = useState(true);
    const [sortedEmail, setSortedEmail] = useState(true)
    const [sortedStatus, setSortedStatus] = useState(true)
    const [sortedDist, setSortedDist] = useState(true)
    const [sortedState, setSortedState] = useState(true);
    const navigate = useNavigate();

    const navigateToMasterCreation = (vendorId) => {
    localStorage.setItem("id", vendorId)
        navigate(`/dashboard/${PAGE_NAME_KEYS.VENDOR_MASTER}/${PAGE_NAME_KEYS.VENDOR_MASTER_CREATION}`)
    }

    const sortingData = (data) => {
        switch (data) {
            case "sortedVendorId":
                if (!sortedVendorId) {
                    const lists = [...vendorsList]
                    lists.sort((a, b) => a.vendorId - b.vendorId)
                    setVendorsList([...lists])
                    setSortedVendorId(true)
                } else {
                    const lists = [...vendorsList]
                    lists.sort((a, b) => b.vendorId - a.vendorId)
                    setVendorsList([...lists])
                    setSortedVendorId(false)
                }
                break;
            case "sortedVendorName":
            if (!sortedVendorName) {
                const lists = [...vendorsList]
                lists.sort((a, b) => a.vendorName?.toLowerCase().localeCompare(b.vendorName?.toLowerCase()))
                setVendorsList([...lists])
                setSortedVendorName(true)
            } else {
                const lists = [...vendorsList]
                lists.sort((a, b) => b.vendorName?.toLowerCase().localeCompare(a.vendorName?.toLowerCase()))
                setVendorsList([...lists])
                setSortedVendorName(false)
            }
            break;
            case "sortedMobile":
                if (!sortedMobile) {
                  const lists = [...vendorsList]
                  lists.sort((a, b) => a.mobileNumber?.toLowerCase().localeCompare(b.mobileNumber?.toLowerCase()))
                  setVendorsList([...lists])
                  setSortedMobile(true)
                } else {
                  const lists = [...vendorsList]
                  lists.sort((a, b) => b.mobileNumber?.toLowerCase().localeCompare(a.mobileNumber?.toLowerCase()))
                  setVendorsList([...lists])
                  setSortedMobile(false)
                }
                break;
            case "sortedEmail":
                if (!sortedEmail) {
                const lists = [...vendorsList]
                lists.sort((a, b) => a.email?.toLowerCase().localeCompare(b.email?.toLowerCase()))
                setVendorsList([...lists])
                setSortedEmail(true)
                } else {
                const lists = [...vendorsList]
                lists.sort((a, b) => b.email?.toLowerCase().localeCompare(a.email?.toLowerCase()))
                setVendorsList([...lists])
                setSortedEmail(false)
                }
                break;
            case "sortedStatus":
                if (!sortedStatus) {
                const lists = [...vendorsList]
                lists.sort((a, b) => a.status?.toLowerCase().localeCompare(b.status?.toLowerCase()))
                setVendorsList([...lists])
                setSortedStatus(true)
                } else {
                const lists = [...vendorsList]
                lists.sort((a, b) => b.status?.toLowerCase().localeCompare(a.status?.toLowerCase()))
                setVendorsList([...lists])
                setSortedStatus(false)
                }
                break;
            case "sortedDist":
                if (!sortedDist) {
                const lists = [...vendorsList]
                lists.sort((a, b) => a.district?.toLowerCase().localeCompare(b.district?.toLowerCase()))
                setVendorsList([...lists])
                setSortedDist(true)
                } else {
                const lists = [...vendorsList]
                lists.sort((a, b) => b.district?.toLowerCase().localeCompare(a.district?.toLowerCase()))
                setVendorsList([...lists])
                setSortedDist(false)
                }
                break;
            case "sortedState":
                if (!sortedState) {
                const lists = [...vendorsList]
                lists.sort((a, b) => a.state?.toLowerCase().localeCompare(b.state?.toLowerCase()))
                setVendorsList([...lists])
                setSortedState(true)
                } else {
                const lists = [...vendorsList]
                lists.sort((a, b) => b.state?.toLowerCase().localeCompare(a.state?.toLowerCase()))
                setVendorsList([...lists])
                setSortedState(false)
                }
                break;
            default:
        }
    }

    return (
        <>
            <section className="p-4">
                <h1 className="headerclaim">Vendor Search</h1>
                <hr className="upper_hr"/>
                {/* <div class="outer-box_vendorMasters"> */}
                    <div className='outer-boxIndividual'>
                    <h2 className="heading_h2Masters">Vendor Search</h2>
                    <div className="inner-boxMasters" style={{backgroundColor:"white"}}>
                        <div className="container-fluid selectButtonsMasters">
                        <AdvanceSearch
                        loading={loading}
                        setLoading={setLoading}
                        showAdvanceSearch={false}
                        setList={setVendorsList}
                        list={vendorsList}
                        searchFields={vendorSearch}
                        setsearchFields={setVendorSearch}
                        setSearchResultMode={setSearchResultMode}
                        module="vendor_master"
                        defaultSearch={defaultSearch}
                        resetFields={defaultSearch}
                        navigateToMasterCreation={navigateToMasterCreation}
                        setResetPagination={setResetPagination}
                        resetPagination={resetPagination}
                        productNames={productNames}
                        />

                        {
                            loading ? (
                                <LoadingPage/>
                            ) : (
                                    vendorsList && vendorsList.length > 0 ? (
                                        <>
                                            <table className="table table-strip mt-3 text-left">
                                                <thead>
                                                    <tr>
                                                        <th scope="col">Vendor ID<a className="pointer text-body ms-1" onClick={() => sortingData("sortedVendorId")}><svg xmlns="http://www.w3.org/2000/svg" className="pointer" width="16" height="16" fill="currentColor" className="bi bi-filter" viewBox="0 0 16 16">
                                                            <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5" />
                                                        </svg></a></th>
                                                        <th>Vendor Name<a className="pointer text-body ms-1" onClick={() => sortingData("sortedVendorName")}><svg xmlns="http://www.w3.org/2000/svg" className="pointer" width="16" height="16" fill="currentColor" className="bi bi-filter" viewBox="0 0 16 16">
                                                            <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5" />
                                                        </svg></a></th>
                                                        <th>Mobile Number<a className="pointer text-body ms-1" onClick={() => sortingData("sortedMobile")}><svg xmlns="http://www.w3.org/2000/svg" className="pointer" width="16" height="16" fill="currentColor" className="bi bi-filter" viewBox="0 0 16 16">
                                                            <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5" />
                                                        </svg></a></th>
                                                        <th>Email<a className="pointer text-body ms-1" onClick={() => sortingData("sortedEmail")}><svg xmlns="http://www.w3.org/2000/svg" className="pointer" width="16" height="16" fill="currentColor" className="bi bi-filter" viewBox="0 0 16 16">
                                                            <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5" />
                                                        </svg></a></th>
                                                        <th>Status<a className="pointer text-body ms-1" onClick={() => sortingData("sortedStatus")}><svg xmlns="http://www.w3.org/2000/svg" className="pointer" width="16" height="16" fill="currentColor" className="bi bi-filter" viewBox="0 0 16 16">
                                                            <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5" />
                                                        </svg></a></th>
                                                        <th>District<a className="pointer text-body ms-1" onClick={() => sortingData("sortedDist")}><svg xmlns="http://www.w3.org/2000/svg" className="pointer" width="16" height="16" fill="currentColor" className="bi bi-filter" viewBox="0 0 16 16">
                                                            <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5" />
                                                        </svg></a></th>
                                                        <th>State<a className="pointer text-body ms-1" onClick={() => sortingData("sortedState")}><svg xmlns="http://www.w3.org/2000/svg" className="pointer" width="16" height="16" fill="currentColor" className="bi bi-filter" viewBox="0 0 16 16">
                                                            <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5" />
                                                        </svg></a></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        currentItems.map(list => (
                                                            <tr>
                                                                <td style={{color: "lightblue"}} className="pointer" onClick={() => navigateToMasterCreation(list.vendorId)}>{list.vendorId}</td>
                                                                <td>{list.vendorName}</td>
                                                                <td>{list.mobileNumber}</td>
                                                                <td>{list.email}</td>
                                                                <td style={{color: "green"}}>{list.status}</td>
                                                                <td>{list.district}</td>
                                                                <td>{list.state}</td>
                                                            </tr>
                                                        ))
                                                    }
                                                </tbody>
                                            </table>
                                            <ListsPagination setCurrentItems={setCurrentItems} lists={vendorsList}/>                                       
                                        </>
                                    ) : <NoDataFound text="No Data Found"/>

                            )
                        }


                    </div>
                </div>
                </div>
            </section>
        </>
    )
};

export default Vendormaster;